import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { latestProjects, project, services } from '../data/data';
import { motion, AnimatePresence } from 'framer-motion';
import { projects } from '../data/worklog';
import animA from '../animations/animA';
import useLink from '../hooks/useLink';
import useMouse from '../hooks/useMouse';
import useWindowSize from '../hooks/useWindowSize';
import useProjectPrev from '../hooks/useProjectPrev';
import SectionTitle from './common/SectionTitle';
import Button from './common/Button';
import ImageMedia from './common/ImageMedia';
import { Section } from './imports';


const Portfolio = ({ prev }) => {

  const s = { title: prev ? <>Projets Récents {/*  */}</> : <> Portfolio<sup className='origin-left-top muted dim hover:unmute= quick text-2xl lg:text-4xl cursor-default'>&nbsp;({projects.length})</sup></> };

  const pathname = useLocation().pathname;

  const { onDesk, onMobile } = useWindowSize();
  const { toPointer, toDefault } = useMouse();
  const { ease, duration } = animA();
  const { /* id,  */ sortBy, sortedBy, thisCurrentProject, layout, setInitialLayout, toList, toGrid, toGrid2 } = useProjectPrev();

  useEffect(() => {
    setInitialLayout(pathname)
  }, [pathname, setInitialLayout])


  // ^^ LAYOUT ACTIONS
  const actions = []
  if (!prev) {
    actions.push(
      { label: "list", onClick: !prev && toList, isActive: layout === "list", icon: "ri-list-unordered" },
    )
  }
  if (!prev) {
    actions.push(
      { label: "grid", onClick: toGrid, isActive: layout === "grid", icon: "ri-layout-grid-fill" },
    )
  }
  if (!prev && !onMobile) {
    actions.push(
      { label: "grid2", onClick: toGrid2, isActive: layout === "grid2", icon: "ri-layout-grid-2-fill" },
    )
  }

  const sortedDate = [...projects].sort((a, b) => b.metadata.year - a.metadata.year);
  const sortedName = [...projects].sort((a, b) => a.client.localeCompare(b.client));
  // const sortedServices = [...projects].sort((a, b) => a.services.localeCompare(b.client));
  const staticLatest = projects.filter((pr => latestProjects.includes((pr.client.toLowerCase()))))
  // console.log(staticLatest)
  const prevLatest = staticLatest /* sortedDate.slice(0, latestProjects.length) */;
  // const prevLatest = projects.find((pr => pr.client.includes(latestProjects.map((latest, i) =>  latest))));

  const mapThis = (dataType) => {
    switch (dataType) {
      case 'name':
        return prev ? prevLatest : sortedName; // Return sortedName if prev is true
      case 'date':
        return prev ? prevLatest : sortedDate; // Return sortedDate if prev is true
      default:
        return prev ? prevLatest : sortedDate; // Return sortedDate for any other value
    }
  };

  const [isClicked, setIsClicked] = useState(false);

  const handleClick = (id) => {
    if (id === thisCurrentProject) {
      setIsClicked(true);
    }
  };

  const dataToMap = prev ? prevLatest : sortedBy;
  const itemsToMap = mapThis(dataToMap);

  // ^ TABLE HEADERS
  const tableHeaders = [
    { label: "Client", filter: "(A-Z)", sortBy: "name" },
    { label: "Services", filter: "(A-Z)" },
    { label: "Date", filter: "(2018-2025)", sortBy: "date" },
  ];
  if (onDesk) {
    tableHeaders.push(
      // { label: "Industry", filter: "(A-Z)" },
      // { label: "Profile", filter: "(Solo - Corporation)" },
    )
  };

  const prLink = useLink();

  return (
    <div style={{ clipPath: "inset(0%)" }} className='flex h-fit relative w-full bg-dark'>

      <Section padded className={`relative items-start min-h-[100vh] lg:pb-[20vh] mb-24 pb-[240px] ${!prev && "pt-[20vh]"} `} >

        <div className='top-[40vh] flex flex-col w-full h-fit pb-24'>
          <div className='flexV resp h-fit'>
            <div className='flex justify-between items-center pb-10'>

              <div className='w-full flex relative'>

                <SectionTitle {...s} className={twMerge(``)} layout={onDesk && prev && "center"} titleCSS={"lg:!text-7xl"} />

                {/* LAYOUT OPTIONS */}
                {!prev &&
                  <motion.div id='portfolioActions' className={twMerge('absolute !right-0 my-auto origin-right group scale-95 quick group hover:scale-100 inset-x-0= w-fit  z-[100] flex items-center px-2 py-2')}>
                    {/* <Button variant={"primary"} className={"mr-"}>
                    <i className='ri-search-line' />
                  </Button> */}
                    <>
                      <div className='viewChange= group-hover:viewChangeHover= quick relative flex items-center gap-2'>
                        {actions.map((action, i) => {
                          return (
                            <Button key={action + i} onClick={action.onClick} variant={"discreet"} className={`px-2 w-fit shrink-0 space-x-2 hover:bg-white/30 ${action.isActive && "!bg-white text-black quicker"}`}>
                              <span className='relative flex overflow-clip aspect-square center size-7'>
                                <i className={`flex size-7  text-center center ri-lg ${action.icon}`} />
                              </span>
                            </Button>
                          )
                        })}
                      </div>
                    </>
                  </motion.div>
                }
              </div>

              {/* TOUS NOS PROJETS */}
              {prev &&
                <div className='absolute w-full inset-x-0 resp flex items-center lg:bottom-36 bottom-40 mx-auto'>
                  <NavLink to={"/work"} /* target='_blank'  */ className={'paddingX w-full flex'}>
                    <Button id="buttonUnderline2" variant="cta" className='max-sm:w-full group hover:scale-100 lg mx-auto uppercase max-sm:border border-white/[.05]'>
                      <h3>Tous nos projets&nbsp;<sup>({projects.length})</sup></h3>
                      <i className='ri-arrow-right-s-line text-primary brightness-150 -rotate-45 translate-x-4 quick group-hover:translate-x-2 ri-xl' />
                    </Button>
                  </NavLink>
                </div>
              }
            </div>

            <h6 className={twMerge(' dim muted md:text-left -translate-y-8 font-poppins',
              layout === "center" && "",
              prev ? " lg:text-center" : ""
            )}>
              {project.copyright}  {/* ©  */}Tous droits réservés.
            </h6>
          </div>

          <div className={twMerge('z-0 flex flex-col w-full h-fit', layout === "list" ? "resp" : "")}>

            <div className='relative flex flex-col mt-20 h-fit w-full'>

              {/* TABLE HEADERS */}
              {layout === "list" && !prev &&
                <div className={twMerge(layout === "list" ? "" : "resp", 'w-full flex border-b border1 pb-3 mb-2 lg:-translate-x-4 lg:px-4')}>
                  {tableHeaders.map((header, i) => {

                    const reverseDateLayout = onMobile && layout === "list" && header.label === "Date"

                    return (
                      <button
                        key={header + i}
                        id={`header` + header.label}
                        onClick={() => sortBy(header.sortBy)}
                        className='flex w-full'
                      >
                        <h4 className={twMerge(reverseDateLayout && "flex flex-row-reverse gap-2 ", 'flex items-center w-full')}>
                          <span className='flex'>{header.label}</span>
                          <span className='flex ml-3 text-sm muted dim'>{header.filter}</span>
                        </h4>
                      </button>
                    )
                  })}
                </div>
              }

              {/* GRID TABLE CONTENT */}
              <div className={twMerge("h-fit w-full",
                layout === "list" && "px-0",
                layout === "grid" && prev && "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-10",
                layout === "grid" && !prev && "grid grid-cols-1 md:grid-cols-2 px-[5vw] gap-10 md:gap-20 lg:gap-4 max-md:resp",
                layout === "grid2" && "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4 gap-10 md:gap-20 lg:gap-4 max-md:resp",
              )}>

                {itemsToMap.map((pr, i) => {

                  const indices = pr.services.map(indArray => indArray - 1).filter(index => index >= 0 && index < services.length)

                  switch (layout) {

                    case "grid":
                    case "grid2": return (
                      <div key={i}>
                        {/* <div className='flex flex-grow absolute z-[-1] opacity-10 signal' /> */}
                        <AnimatePresence mode='wait'>
                          <motion.div key={i} onClick={() => handleClick(pr.client)}
                            initial={{ opacity: .7, scale: .8, width: "100%", clipPath: "inset(0% 0% 50%)", filter: 'brightness(.4)' }}
                            /*   animate={isClicked && pr.client === id ?
                                { opacity: 1, zIndex: 200, position: "fixed", width: "100vw", height: "100vh", inset: "0%", clipPath: "inset(0% 0%)" }
                                :
                                { opacity: 1, zIndex: 200, position: "relative", width: "100%", height: "100%", inset: "0%", clipPath: "inset(0% 0%)" }
                              } */
                            whileInView={{ opacity: 1, scale: 1, clipPath: "inset(0%)", filter: 'brightness(1)' }}

                            // exit={{ opacity: 1, clipPath: "inset(0% 0%)" }}
                            // whileTap={{ opacity: 1, zIndex: 200, position: "fixed", width: "100vw", height: "100vh", transformOrigin:"bottom", inset: "0%", clipPath: "inset(0% 0%)" }}
                            exit={{ delay: 2 }}
                            transition={{ ease, duration, }}
                            viewport={{ once: true, amount: "some" }}

                            onMouseEnter={toPointer}
                            onMouseLeave={toDefault}

                            className={twMerge('group relative= flex flex-col h-fit')}
                          >
                            <div className='flex flex-col aspect-video w-full h-full relative'>

                              {pr.starred &&
                                <div className='absolute right-4 bottom-4 size-8 flex center z-[3]'>
                                  <i className='ri-bookmark-fill animate-pulse text-white mix-blend-difference ri-lg' />
                                </div>
                              }

                              <div className='absolute inset-0 bg-dark/20 z-[1] group-hover:opacity-0 quick pointer-events-none' />

                              <div className='flex flex-col flex-grow w-full h-full relative'>
                                <NavLink to={`/work/${prLink(pr.client)}`} onClick={() => { thisCurrentProject(prLink(pr.client)) }} className={'relative flex center full'}>

                                  <motion.div initial={{ clipPath: onDesk ? 'inset(.6rem)' : "inset(0rem)" }}
                                    whileHover={{ clipPath: 'inset(0rem)' }}
                                    transition={{ ease }}
                                    className='flex flex-grow relative center full p-0 m-0' >

                                    {pr.client !== thisCurrentProject && !isClicked &&
                                      <div className='overlayOnContent pointer-events-none absolute flex flex-col inset-0 items-end justify-end bg-gradient-to-t from-dark/50 h-[40%] mt-auto bottom-0 p-3 z-[2]'>
                                        <p className='w-full max-sm:text-right flex items-start justify-start pointer-events-auto muted group-hover:unmute -space-x-[1px] quick pl-2'>
                                          {indices.map((index, i) => (
                                            <button key={"serviceIndex" + i} onMouseEnter={toDefault} onMouseLeave={toPointer} className='h-fit'>
                                              <span className='cursor-default w-fit whitespace-nowrap border border1 px-2 py-1 rounded-lg text-xs bg-zinc-9500== bg-zinc-500/20 backdrop-blur-lg hover:bg-white= lg:group-hover:bg-white lg:group-hover:text-blakk =hover:text-blakk quick'>
                                                {services[index].short.trim()}
                                              </span>
                                            </button>
                                          ))}
                                        </p>
                                      </div>
                                    }

                                    {/* THUMBNAIL */}
                                    {/* <DefaultContent /> */}
                                    {pr.metadata.heroVideo ?
                                      <video className={twMerge("relative z-[1] full flex center object-cover", pr.metadata?.heroVidCSS)} autoPlay muted loop playsInline>
                                        <source src={require(`../projects/${prLink(pr.client)}/${pr.metadata.heroVideoPrev || pr.metadata.heroVideo}`)} />
                                      </video>
                                      :
                                      <ImageMedia
                                        bypass
                                        src={require(`../projects/${prLink(pr.client)}/${pr.metadata.thumbnail}`)}
                                        title={"LAWWD for " + pr.client}
                                        loading="lazy"
                                        className={`!object-cover full ${pr.metadata.css} ${pr.metadata.heroVideo && "opacity-0"} `}
                                      />
                                    }
                                  </motion.div>
                                </NavLink>
                              </div>
                            </div>
                            <div className='mt-3'>
                              <div className='flex items-start justify-between w-full paddingX pl-5 pr-0'>
                                <NavLink to={`/work/${prLink(pr.client)}`} onClick={() => thisCurrentProject(prLink(pr.client))} className={"w-full"}>
                                  <h4 className='capitalize w-full inline'>{pr.client}
                                    {pr.locked && <span className='size-8 inline ml-2 center z-[3]'>
                                      <i className='ri-lock-fill animate-pulse text-white/50 mix-blend-difference ri-sm' />
                                    </span>
                                    }</h4>
                                  <h5 className='md:text-[18px] -mt-1= lg:landscape:opacity-0 lg:landscape:group-hover:opacity-40 !line-clamp-2 capitalize text-balance dim muted group-hover:unmute quick leading-[120%] mt-[8px]='>{pr.metadata.descr}</h5>
                                </NavLink>
                              </div>
                            </div>
                          </motion.div>
                        </AnimatePresence>
                      </div>
                    )

                    default: return (
                      <div key={i} className={twMerge('group lg:muted hover:unmute py-1 hover:lg:bg-white/5 lg:-translate-x-4 border-b border1')}>
                        <div className='flex justify-start items-center text-neutral-400 unmute lg:px-4'>

                          {tableHeaders.find((table => table.label === "Client")) &&
                            <h4 id="headerClient" className='relative group-hover:text-white items-center'>
                              <NavLink to={`/work/${prLink(pr.client)}`} onMouseEnter={toPointer} onMouseLeave={toDefault} className={"w-fit"} >
                                <span className='relative w-fit min-w-[20ch] flex items-center'>
                                  {pr.client}
                                  {pr.locked && < i className='ml-2 ri-sm ri-lock-fill inline-flex group-hover:animate-pulse' />}
                                  <span className='opacity-0 rotate-45= group-hover:opacity-100 group-hover:rotate-0 quick absolute left-0 size-10 translate-x-[-120%] overflow-hidden  flex center rounded-full'>
                                    <i className='flex center size-10 -rotate-45 ri-arrow-right-line' />
                                  </span>
                                </span>
                              </NavLink>
                            </h4>
                          }

                          {tableHeaders.find((table => table.label === "Services")) &&
                            <h4 id="headerServices" className=' w-full max-sm:text-right items-center justify-end'>
                              {indices.map((index, i) => {
                                // console.log(index)
                                // const reIndex = index
                                return (
                                  <span key={"serviceIndex" + i} className='lg:w-fit max-sm:muted whitespace-nowrap muted'>
                                    <span className='flex++++++max-lg:portrait:hidden !font-light'>
                                      {services[index].short.trim()}{i < indices.length - 1 && ","}
                                    </span>
                                    {/* ICON FOR SMALL DEVICES */}
                                    {/* <span className='max-lg:portrait:flex hidden'>
                                  <i className={`${services[index].icon} `} />
                                  </span> */}
                                  </span>
                                )
                              })}
                            </h4>
                          }

                          {tableHeaders.find((table => table.label === "Date")) &&
                            <h4 id="headerDate" className='muted w-full'>{pr.metadata.year}</h4>
                          }

                          {/* {onDesk && tableHeaders.find((table => table.label === "Industry")) &&
                            <>
                              <h4 id="headerIndustry" className='muted'>{pr.metadata.industry[0]}</h4>
                            </>
                          } */}
                        </div>

                        {/* PR CONTENT ON HOVER */}
                        <div className='collapse overflow-y-clip group-hover:visible quick w-full h-0 group-hover:min-h-[256px] max-h-[520px] flex flex-col items-start justify-between resp'>
                          {pr.metadata.descr &&
                            <div className='inline-flex items-center dim muted'>
                              <h4 className='noaction font-light'>{pr.metadata.descr}</h4>
                            </div>
                          }
                          <div className='w-fit flex items-start gap-10 h-full paddingY pb-6'>
                            {/* <DefaultContent /> */}
                            <NavLink to={`/work/${prLink(pr.client)}`} onMouseEnter={toPointer} onMouseLeave={toDefault} className='flex relative h-full hover:scale-105 oneSecond '>
                              <ImageMedia
                                bypass
                                src={require(`../projects/${prLink(pr.client)}/${pr.metadata.thumbnail}`)}
                                title={prLink(pr.client)}
                                className="h-full !aspect-video "
                                loading="lazy"
                              />
                            </NavLink>
                            {/* <DefaultContent /> */}
                          </div>
                        </div>

                      </div>
                    )
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </Section >
    </div >
  )
}

export default Portfolio
